/* NXT cross-sell — "add an accessory, save 10%". No dependencies.
   Pairs with snippets/cross-sell.liquid + sections/cross-sell.liquid.
   The discount itself is a native Shopify Buy X Get Y automatic discount;
   this file only keeps the storefront UI in sync. */
(function () {
  'use strict';

  var SECTION = 'cross-sell';

  /* Post-add popup behaviour.
       'on-drawer-close' — arm on add, then show the offer once the shopper
                           closes the cart drawer. (default)
       'immediate'       — show straight after an add, on top of the drawer.
       'off'             — never show it. */
  var POPUP_MODE = 'on-drawer-close';

  /* Stop nagging after this many popups in one browsing session. */
  var MAX_POPUPS_PER_SESSION = 2;

  var R = (window.NXT && window.NXT.routes) || {};
  var nativeFetch = window.fetch.bind(window);

  function $(s, c) { return (c || document).querySelector(s); }
  function slots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-xsell-slot]:not([data-xsell-static])')
    );
  }

  /* --------------------------------------------------------------- refresh */
  function refresh() {
    var targets = slots();
    if (!targets.length) return Promise.resolve('');

    return nativeFetch(window.location.pathname + '?section_id=' + SECTION, {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html == null) return '';
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var root = tmp.querySelector('[data-xsell-root]');
        var inner = root ? root.innerHTML : '';
        targets.forEach(function (s) { s.innerHTML = inner; });
        return inner.trim();
      })
      .catch(function () { return ''; });
  }

  /* ----------------------------------------------------------------- popup */
  var drawerEl = $('[data-cart-drawer]');

  function drawerOpen() {
    return !!drawerEl && drawerEl.getAttribute('data-open') === 'true';
  }
  function popupEl() { return $('[data-xsell-popup]'); }
  function hasOffer() { return !!$('[data-xsell-popup] [data-xsell]'); }

  function shownCount() {
    try { return parseInt(sessionStorage.getItem('xsell_popups') || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpCount() {
    try { sessionStorage.setItem('xsell_popups', String(shownCount() + 1)); } catch (e) {}
  }

  function setPopup(open) {
    var p = popupEl();
    if (!p) return;
    p.setAttribute('data-open', open ? 'true' : 'false');
    p.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  /* armed = an add just happened and the offer is still owed a showing */
  var armed = false;
  var sawDrawerOpen = false;
  var fallbackTimer;

  function arm() {
    if (POPUP_MODE === 'off') return;
    if (shownCount() >= MAX_POPUPS_PER_SESSION) return;

    armed = true;
    sawDrawerOpen = drawerOpen();

    if (POPUP_MODE === 'immediate') { fire(); return; }

    /* If the drawer never opens (theme change, cart page, JS error) don't
       swallow the offer — show it anyway shortly after. */
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function () {
      if (armed && !drawerOpen() && !sawDrawerOpen) fire();
    }, 1800);
  }

  function fire() {
    if (!armed) return;
    armed = false;
    clearTimeout(fallbackTimer);
    if (!hasOffer()) return;
    bumpCount();
    setPopup(true);
  }

  /* watch the drawer: show the offer the moment it is dismissed */
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawerOpen()) {
        sawDrawerOpen = true;
        clearTimeout(fallbackTimer);
      } else if (armed && sawDrawerOpen && POPUP_MODE === 'on-drawer-close') {
        fire();
      }
    }).observe(drawerEl, { attributes: true, attributeFilter: ['data-open'] });
  }

  /* ------------------------------------------------------------------- add */
  /* Reuse the theme's own add-to-cart pipeline by submitting a throwaway
     [data-add-form]. theme.js then handles the POST, re-renders the cart and
     opens the drawer, so there is no duplicated cart logic here. */
  function addVariant(variantId) {
    var f = document.createElement('form');
    f.setAttribute('data-add-form', '');
    f.setAttribute('method', 'post');
    f.setAttribute('action', R.cart_add || '/cart/add');
    f.hidden = true;
    f.innerHTML =
      '<input type="hidden" name="id" value="' + String(variantId).replace(/[^0-9]/g, '') + '">' +
      '<input type="hidden" name="quantity" value="1">' +
      '<button type="submit"></button>';
    document.body.appendChild(f);

    if (typeof f.requestSubmit === 'function') f.requestSubmit();
    else $('button', f).click();

    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 5000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-xsell-add]');
    if (btn) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('loading');
      /* adding from inside the popup shouldn't re-trigger the popup */
      if (btn.closest('[data-xsell-popup]')) setPopup(false);
      addVariant(btn.getAttribute('data-variant-id'));
      return;
    }
    if (e.target.closest('[data-xsell-close]')) {
      e.preventDefault();
      setPopup(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setPopup(false);
  });

  /* --------------------------------------------- react to cart mutations */
  var timer;
  function onCartMutated(wasAdd) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      refresh().then(function (html) {
        if (wasAdd && html) arm();
      });
    }, 250);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function (r) { if (r && r.ok) onCartMutated(/\/cart\/add/.test(url)); })
       .catch(function () {});
    }
    return p;
  };
})();
